"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Play, Phone, Mic, Sparkles, Check, X } from "lucide-react";
import Sketch from "react-p5";
import p5Types from "p5";
const SHARED_DATA = {
  business_name: "Cyril Consulting Group",
  phone: "+1 (555) 987-6543"
};
export default function TheFutureOfYourFrontDesk() {
  const [date, setDate] = useState<Date | undefined>(new Date());
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const setup = (p5: p5Types, canvasParentRef: Element) => {
    p5.createCanvas(p5.windowWidth < 768 ? p5.windowWidth : p5.windowWidth / 2, 600).parent(canvasParentRef);
    p5.frameRate(60);
  };
  const draw = (p5: p5Types) => {
    p5.clear();
    if (p5.frameCount % 5 === 0) {}
    p5.noFill();
    p5.strokeWeight(2);
    const time = p5.frameCount * 0.05;
    for (let i = 0; i < 3; i++) {
      p5.stroke(0, 128, 128, 150 - i * 40);
      p5.beginShape();
      for (let x = 0; x < p5.width; x += 10) {
        const y = p5.height / 2 + p5.sin(x * 0.01 + time + i) * 50 * p5.sin(time * 0.5) + i * 20;
        p5.vertex(x, y);
      }
      p5.endShape();
    }
    p5.noStroke();
    p5.fill(212, 175, 55, 150);
    const particleCount = 20;
    for (let i = 0; i < particleCount; i++) {
      const x = (p5.width * (i + 1) / particleCount + p5.sin(time + i) * 20) % p5.width;
      const y = (p5.height * (i + 1) / particleCount + p5.cos(time + i) * 20) % p5.height;
      const size = (p5.sin(time * 2 + i) + 2) * 2;
      p5.circle(x, y, size);
    }
  };
  const windowResized = (p5: p5Types) => {
    p5.resizeCanvas(p5.windowWidth < 768 ? p5.windowWidth : p5.windowWidth / 2, 600);
  };
  return <section data-section-id="31195" id="pioneering-your-digital-evolution" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-accent-foreground/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-secondary/10 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="flex flex-col gap-8 max-w-2xl">
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight leading-[1.1]">AI, Cloud, and Automation Consulting That Drives <span className="bg-gradient-to-r from-secondary to-accent-foreground bg-clip-text text-transparent" data-ast-id="f:/src/pages/Home/sections/TheFutureOfYourFrontDesk.tsx|sig:r0gaeh" data-ast-start="2781" data-ast-end="3018">Business Growth</span></h1>
            
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-lg">Enterprise-quality AI strategy, cloud solutions, and automation — built for growing businesses, restaurants, hotels, and content creators who can't afford to wait.</p>

            <div className="flex flex-wrap gap-4">
              <Button asChild size="lg" className="text-base px-8 h-12 rounded-full shadow-lg shadow-secondary/20 bg-secondary text-secondary-foreground hover:bg-secondary/90">
                <Link to="/LetsTalkPage">
                  Schedule Consultation
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="text-base px-8 h-12 rounded-full border-white/10 bg-white/5 hover:bg-white/10 backdrop-blur-sm">
                <Link to="#">
                  <Play className="mr-2 size-4 fill-current text-accent-foreground" />
                  Watch Strategy
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-4 text-sm text-muted-foreground mt-4">
              <div className="flex -space-x-2">
                {[1, 2, 3].map(i => <div key={i} className="size-8 rounded-full border-2 border-background bg-muted flex items-center justify-center overflow-hidden">
                     <img src={`/img/avatar_user_${i}.png`} alt="User" className="w-full h-full object-cover" />
                  </div>)}
              </div>
              <p className="font-mono tracking-wider uppercase text-[10px]">Trusted by 500+ global enterprises</p>
            </div>
          </div>

          {}
          <div className="relative h-[500px] w-full flex items-center justify-center perspective-[1000px]">
            
            {}
            <div className="absolute inset-0 opacity-60 pointer-events-none">
               {isMounted && <Sketch setup={setup} draw={draw} windowResized={windowResized} className="w-full h-full" />}
            </div>

            {}
            <div className="relative w-full max-w-md aspect-square animate-[float_6s_ease-in-out_infinite]">
              
              {}
              <div className="absolute top-10 right-0 md:right-10 z-10 transform rotate-y-[-10deg] rotate-x-[5deg] transition-transform hover:rotate-0 duration-500">
                <div className="bg-card/40 backdrop-blur-xl border border-white/10 rounded-2xl p-4 shadow-2xl shadow-black/50">
                  <div className="flex items-center justify-between mb-4 px-2">
                    <span className="text-xs font-mono font-semibold text-foreground/80">AI READINESS</span>
                    <Sparkles className="size-4 text-secondary" />
                  </div>
                  <SafeHydrate><Calendar mode="single" selected={date} onSelect={setDate} className="rounded-md border border-white/5 bg-black/20 text-foreground" /></SafeHydrate>
                </div>
              </div>

              {}
              <div className="absolute bottom-20 left-0 md:-left-4 z-20 transform translate-z-[50px] animate-[float_8s_ease-in-out_infinite_reverse]">
                <div className="bg-background/60 backdrop-blur-2xl border border-accent-foreground/30 rounded-2xl p-5 shadow-2xl shadow-accent-foreground/10 w-72">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="relative">
                      <div className="size-12 rounded-full bg-gradient-to-br from-accent-foreground to-primary flex items-center justify-center">
                        <Mic className="size-6 text-white" />
                      </div>
                      <span className="absolute -bottom-1 -right-1 size-3 bg-accent-foreground border-2 border-background rounded-full animate-pulse"></span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground">Strategy AI</h3>
                      <p className="text-xs text-accent-foreground animate-pulse">Analyzing Data...</p>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="h-1.5 w-full bg-muted/50 rounded-full overflow-hidden">
                      <div className="h-full bg-accent-foreground w-2/3 animate-[width_2s_ease-in-out_infinite]"></div>
                    </div>
                    <div className="flex gap-3 mt-4">
                      <Button size="sm" className="flex-1 bg-destructive/20 hover:bg-destructive/30 text-destructive border border-destructive/50">
                        <X className="size-4 mr-1" /> Dismiss
                      </Button>
                      <Button size="sm" className="flex-1 bg-accent-foreground/20 hover:bg-accent-foreground/30 text-accent-foreground border border-accent-foreground/50">
                        <Check className="size-4 mr-1" /> Review
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute top-0 right-20 z-0">
                 <div className="size-24 rounded-full bg-secondary/10 blur-2xl animate-pulse"></div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <style jsx global>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes width {
          0%, 100% { width: 30%; }
          50% { width: 80%; }
        }
      `}</style>
    </section>;
}